class AssessibleSwitch {
  constructor() {
    this.list = []
    this.status = undefined
    this.box = null
    this.init()
  }
  init () {
    try {
      this.status = JSON.parse(localStorage.getItem('AssessibleStatus'))
    } catch (e) {
      this.status = true
    }
    if (this.status === null) {
      this.status = true
    }
    this.box = document.querySelector('.switch-box')
    if (this.box) {
      const box = document.getElementById('switchCheckbox')
      box.checked = !!this.status
      box.addEventListener('input', (e) => {
        this.status = e.target.checked
        localStorage.setItem('AssessibleStatus', JSON.stringify(this.status))
        this.initEvent()
      })
    }
    console.log(this.box)
    this.getListBox()
  }
  getListBox() {
    const i = document.querySelector('.aa-cc-body-fix-compliance-part.aa-cc-bottom-right.aa-mm-cc-bottom-right.aa-cc-link-disable')
    if (i) {
      this.initEvent()
    } else {
      setTimeout(() => {
        this.getListBox()
      }, 500)
    }
  }

  initEvent () {
    if (!this.status) {
      this.box && this.box.classList.remove('active')
      this.box && this.box.classList.add('disable')
      const i = document.querySelector('.aa-cc-body-fix-compliance-part.aa-cc-bottom-right.aa-mm-cc-bottom-right.aa-cc-link-disable')
      this.list.push(document.documentElement.removeChild(i))
      console.log(this.list)
    } else {
      this.box && this.box.classList.add('active')
      this.box && this.box.classList.remove('disable')
      this.list.length && this.list.forEach(i => {
        document.documentElement.append(i)
      })
      this.list = []
    }
  }
}
